module.exports = [{"id":1,"vrsta_dela":"Proizvodnja in dostava betona","objekt":"SUMIDA, Blejska Dobrava","narocnik":"Kovinar - Gradnje ST, d.o.o.","image":"sumida"},{"id":2,"vrsta_dela":"Čiščenje in odvoz naplavin reke Pišnice","objekt":"HE Kranjska Gora","narocnik":"Gorenjske elektrarne, d.o.o.","image":"jasna"}]


//////////////////
// WEBPACK FOOTER
// ./src/components/References/References.json
// module id = CgLd
// module chunks = 1